import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import "@babel/polyfill";
import VueSweetalert2 from "vue-sweetalert2";
import VeeValidate from "vee-validate";
import { ValidationObserver, ValidationProvider } from "vee-validate";
// import ar from "vee-validate/dist/locale/ar";
import ar from "./locales/ar.js";

Vue.config.productionTip = false;

Vue.component("ValidationObserver", ValidationObserver);
Vue.component("ValidationProvider", ValidationProvider);

Vue.use(VueSweetalert2);
Vue.use(VeeValidate, {
  locale: "ar",
  dictionary: {
    ar: ar,
  },
});

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount("#app");
